import { Outlet } from 'react-router-dom'

import Eleventhgrade_k11_subjects from './eleventhgrade_k11_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Eleventhgrade_k11 = ( ) => {
 
  return (
    <>
   
   <TopNavbar />
  <Eleventhgrade_k11_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Eleventhgrade_k11;